module.exports = __webpack_public_path__ + "img/arrow.cbf40fd4.svg";